"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("../icon"));

var _checkbox = _interopRequireDefault(require("../checkbox"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getFormattedOptions", function () {
      var options = _this.props.options; // $FlowFixMe

      return options.map(function (option, key) {
        var name;
        var value;

        if (_typeof(option) === "object") {
          name = option.name;
          value = option.value;
        } else {
          name = option;
          value = option;
        }

        return {
          name: name,
          value: value
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeDropdown", function () {
      _this.setState({
        isOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (option, shouldAdd) {
      var selections = _this.state.values;
      var values = shouldAdd ? [].concat(_toConsumableArray(selections), [option]) : selections.filter(function (_ref) {
        var value = _ref.value;
        return value !== option.value;
      });

      _this.setState({
        values: values,
        isOpen: false
      });

      _this.props.onChange(values);
    });

    _defineProperty(_assertThisInitialized(_this), "getOptions", function () {
      var _this$state = _this.state,
          options = _this$state.options,
          values = _this$state.values;

      if (options && options.length > 0) {
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, options.map(function (_ref2, key) {
          var value = _ref2.value,
              name = _ref2.name;
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "dropdown-list-item",
            key: "".concat(key, "_").concat(value)
          }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
            value: values.filter(function (option) {
              return option.value.toString() === value.toString();
            }).length > 0,
            onChange: function onChange(shouldAdd) {
              return _this.onClick({
                value: value,
                name: name
              }, shouldAdd);
            }
          }), name);
        }));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "getFieldErrors", function (error) {
      return error !== null ? /*#__PURE__*/_react.default.createElement("ul", {
        className: "form-errors"
      }, /*#__PURE__*/_react.default.createElement("li", null, error)) : "";
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDropdown", function () {
      var options = _this.props.options;

      if (options && options.length > 0) {
        _this.setState(function (state) {
          return {
            isOpen: !state.isOpen
          };
        });
      }
    });

    _this.state = {
      isOpen: false,
      values: props.values ? props.values : [],
      options: []
    }; // $FlowFixMe Forced to do that for perf issues

    _this.onClickInput = _this.onClickInput.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var options = this.getFormattedOptions();
      this.setState({
        options: options
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.options !== this.props.options) {
        var options = this.getFormattedOptions(); // eslint-disable-next-line react/no-did-update-set-state

        this.setState({
          options: options
        });
      }
    }
  }, {
    key: "onClickInput",
    value: function onClickInput() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          isOpen = _this$state2.isOpen,
          values = _this$state2.values;
      var _this$props = this.props,
          options = _this$props.options,
          placeholder = _this$props.placeholder,
          error = _this$props.error,
          hasShadow = _this$props.hasShadow,
          className = _this$props.className;
      var isSelected = values.length > 0;
      var hasErrors = error !== null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "form-block ".concat(className)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("form-multi-select", {
          "dropdown-open": isOpen,
          "has-errors": hasErrors,
          "with-shadow": hasShadow
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "selected-dropdown",
        onClick: this.toggleDropdown
      }, isSelected ? /*#__PURE__*/_react.default.createElement("span", null, values.length, " selected") : /*#__PURE__*/_react.default.createElement("span", {
        className: "placeholder"
      }, placeholder), /*#__PURE__*/_react.default.createElement("span", {
        className: "selector pull-right"
      }, isOpen && options && options.length > 0 ? /*#__PURE__*/_react.default.createElement(_icon.default, {
        icon: "chevron-up"
      }) : /*#__PURE__*/_react.default.createElement(_icon.default, {
        icon: "chevron-down"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-list"
      }, this.getOptions(), " ")), isOpen && /*#__PURE__*/_react.default.createElement("div", {
        className: "select-background",
        onClick: this.closeDropdown
      })), this.getFieldErrors(error));
    }
  }]);

  return Select;
}(_react.Component);

_defineProperty(Select, "defaultProps", {
  onChange: function onChange() {},
  error: null,
  hasShadow: false,
  className: ""
});

Select.propTypes = {
  onChange: _propTypes.default.func,
  options: _propTypes.default.array.isRequired,
  placeholder: _propTypes.default.string.isRequired,
  error: _propTypes.default.string,
  hasShadow: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = Select;
exports.default = _default;